import { Component, OnInit } from '@angular/core';
import {EventService } from '../../services/event.service';
import { FormService } from 'src/app/services/form.service';
import { FontsService } from 'src/app/services/fonts.service';
import * as moment from 'moment';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss'],

})
export class PrivacyComponent implements OnInit {
  
  constructor(private eventservice: EventService, private formService: FormService, private fontService: FontsService) {
   }

  ngOnInit() {
   

  }

  
}
